(function () {
  function initDrawers(root) {
    if (root.dataset.drawersReady === 'true') return;
    root.dataset.drawersReady = 'true';

    function closeAll() {
      root.querySelectorAll('[data-er-drawer]').forEach(function (drawer) {
        drawer.classList.remove('open');
        drawer.setAttribute('aria-hidden', 'true');
      });
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-er-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        closeAll();
        var drawer = root.querySelector('[data-er-drawer="' + button.dataset.erOpen + '"]');
        if (!drawer) return;
        drawer.classList.add('open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });

    root.querySelectorAll('[data-er-close], .er-ocean__mobile-nav a').forEach(function (item) {
      item.addEventListener('click', closeAll);
    });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeAll(); });
  }

  function initProducts(root) {
    var product = root.querySelector('[data-er-product]');
    if (!product || product.dataset.ready === 'true') return;
    product.dataset.ready = 'true';
    var image = product.querySelector('[data-er-product-image]');
    var label = product.querySelector('[data-er-selected-label]');
    var tabs = Array.prototype.slice.call(product.querySelectorAll('[data-er-product-tab]'));
    var panels = Array.prototype.slice.call(product.querySelectorAll('[data-er-product-panel]'));

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (item) {
          item.classList.toggle('active', item === tab);
          item.setAttribute('aria-selected', item === tab ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          panel.classList.toggle('active', panel.dataset.erProductPanel === tab.dataset.erProductTab);
        });
        if (image) image.src = tab.dataset.image;
        if (label) label.textContent = tab.dataset.label;
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-er-ocean]').forEach(function (root) {
      initDrawers(root);
      initProducts(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
